export type FeatureProperties = { [key: string]: string };

export const parseFeatureProperties = (obj: FeatureProperties): { [key: string]: any } => {
    const safeJSONParse = (str: string) => {
        try {
            return JSON.parse(str);
        } catch (e) {
            return false;
        }
    };

    Object.keys(obj).forEach(key => {
        const parsedJSON = safeJSONParse(obj[key]);

        obj[key] = parsedJSON || obj[key];
    });

    return obj;
};
